// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"hsmd48Ci","title":"_3eLGOmt4","subtitle":"_3kI0qRwI","description":"_2bCGm3g7"};